import { lazy } from '@loadable/component';

const Chart = lazy(
  () => import(/* webpackChunkName: "Charts" */ 'components/chart/charts_new')
);

const OrderBook = lazy(
  () => import(/* webpackChunkName: "OrderBookNew" */ 'components/orderbookNew')
);

const RecentTrade = lazy(
  () => import(/* webpackChunkName: "RecentTradeNew" */ 'components/RecentTradeNew')
);

export { Chart, OrderBook, RecentTrade };
